<div class="basicrow f-black roboto-r f-reg m-top-ii text-center">
        <div class="shortcont">
            <div class="basicrow m-top-ii">
                <div class="basicrow">
                    <label class="label-f">
                        &#42; Direcci&oacute;n 1
                    </label>

                    <input class="inp-f"  [(ngModel)]="AddressDet">
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        Direcci&oacute;n 2
                    </label>

                    <input class="inp-f" [(ngModel)]="AddressDet2">
                </div>

                <div class="basicrow">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                            <label class="label-f">
                                &#42; Ciudad
                            </label>

                            <input class="inp-f"  [(ngModel)]="City">
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                            <label class="label-f">
                                &#42; Estado
                            </label>

                            <input class="inp-f off"  [(ngModel)]="State" readonly>
                        </div>
                    </div>
                </div>

                <div class="basicrow">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                            <label class="label-f">
                                &#42; Pais
                            </label>

                            <input class="inp-f off"  [(ngModel)]="Country" readonly>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                            <label class="label-f">
                                C&oacute;digo Postal
                            </label>

                            <input [appZipCode] class="inp-f" maxlength="10"  [(ngModel)]="ZipCode">
                        </div>
                    </div>
                </div>
                
            </div>

            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>

            <div class="basicrow m-top-i text-center">
                <a class="btns def-iv red centr vcenter">
                    <span class="tabcell" (click)="this.updateDir();">
                        Guardar Cambios&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
